import React, { useState, useEffect } from "react";
import Welcome_to_the_world_com_application from "./welcome_component/Welcome_to_the_world_com_application";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import RegisterHeader from "./Components/RegisterHeader.js";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Newregisterfile from "./welcome_component/Newregisterfile";
import Next_Course from "./Demo/Resumes/Resumes2/Next_Course";
import LoginHeader from "./Components/LoginHeader";
import HomeHeader from "./Components/HomeHeader";
import How_To_Use from "./Components/How_To_Use";
import Courses from "./Demo/Resumes/Courses";
import Mysql_database from "./Demo/Mysql_database";
import Refugees from "./Components/Refugees";
import Sidebar2 from "./Components/Sidebar2";
import Profiles from "./Components/Profiles";
import SideBar_left from "./Components/SideBar_left";
import Posts from "./Components/Posts.js";
import Blog_1 from "./Components/Blog_1";
import Follower from "./Components/Follower";
import Login from "./Components/Login";
import Test from "./Components/Test";
import { auth } from "./firebase";
import "./App.css";
import { LanguageProvider } from "./containers/Language";
import ReactGa from "react-ga";
function App() {
  const [isDark, setIsDark] = React.useState(false);

  useEffect(() => {
    ReactGa.initialize("G-X7DM8SPJ7E");
    /*======+
 |REPORT the page view|
 +======*/

    ReactGa.pageview("/");
  });
  /**
   * ! login section: if user has been registered let it go in, if not, redirected it to the registration page.
   */
  const [user, setUser] = useState([]);
  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        setUser(authUser);
      } else {
        setUser(false);
      }
    });
  }, []);

  return (
    <LanguageProvider>
      <div
        className={`${
          isDark ? "dark" : ""
        } app dark:bg-dark-300 text-black dark:text-white `}
      >
        <Router className="app">
          <Switch>
            <Route path="/login">
              <LoginHeader />

              <Login />
            </Route>

            <Route path="/Welcome_to_the_world_com_application">
              <Welcome_to_the_world_com_application />
            </Route>

            <Route path="/Newregisterfile">
              <RegisterHeader />
              <Newregisterfile />
            </Route>

            <Route path="/Blog_1">
              <Blog_1 />
            </Route>

            <Route path="/How_To_Use">
              <How_To_Use />
            </Route>

            <Route path="/Follower">
              <Follower user={user} />
            </Route>

            <Route path="/Test">
              <Test />
            </Route>

            <Route path="/Mysql_database">
              <Mysql_database />
            </Route>

            <Route path="/Get-My-Free-Courses-Or-Watch-Them-On-Yout-Ube">
              <Courses />
            </Route>

            <Route path="/Next_Course">
              <Next_Course />
            </Route>

            <Route path="/Refugees">
              <Refugees />
            </Route>

            <Route path="/:username/:uid">
              <HomeHeader user={user} />

              <Profiles user={user} />
            </Route>

            <Route path="/">
              <HomeHeader user={user} selected />
              <div className="app__page">
                <SideBar_left user={user} />

                <div className="app__posts">
                  <Posts user={user} />
                </div>
                <Sidebar2 user={user} />
              </div>
            </Route>
          </Switch>
        </Router>
      </div>
    </LanguageProvider>
  );
}

export default App;
